// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"26e125ed","235":"988e240b","441":"ff84fe50","777":"6c0cc125"}[chunkId] + ".chunk.js";
};